module.exports = __webpack_public_path__ + "assets/img/mecha-2fc5824b.png";